export var NKSelectL = [
    // 0-16
    { NKSelectL: { '0': 286.51, '600': 295.81, '1200': 236.51, '3000': 148.87 } },
    // 17-20
    { NKSelectL: { '0': 340.65, '600': 327.3, '1200': 290.65, '3000': 227.52 } },
    // 21
    { NKSelectL: { '0': 425.39, '600': 401.11, '1200': 321.83, '3000': 227.14 } },
    // 22
    { NKSelectL: { '0': 433.5, '600': 410.68, '1200': 330.09, '3000': 233.62 } },
    // 23
    { NKSelectL: { '0': 441.89, '600': 420.57, '1200': 338.61, '3000': 240.24 } },
    // 24
    { NKSelectL: { '0': 450.49, '600': 430.73, '1200': 347.33, '3000': 246.97 } },
    // 25
    { NKSelectL: { '0': 459.05, '600': 440.72, '1200': 356.01, '3000': 253.71 } },
    // 26
    { NKSelectL: { '0': 467.62, '600': 450.67, '1200': 364.68, '3000': 260.49 } },
    // 27
    { NKSelectL: { '0': 476.18, '600': 460.51, '1200': 373.32, '3000': 267.29 } },
    // 28
    { NKSelectL: { '0': 484.69, '600': 470.22, '1200': 381.9, '3000': 274.09 } },
    // 29
    { NKSelectL: { '0': 493.12, '600': 479.81, '1200': 390.39, '3000': 280.88 } },
    // 30
    { NKSelectL: { '0': 501.38, '600': 489.18, '1200': 398.71, '3000': 287.57 } },
    // 31
    { NKSelectL: { '0': 509.47, '600': 498.26, '1200': 406.83, '3000': 294.13 } },
    // 32
    { NKSelectL: { '0': 517.39, '600': 507.12, '1200': 414.78, '3000': 300.6 } },
    // 33
    { NKSelectL: { '0': 525.38, '600': 516.01, '1200': 422.79, '3000': 307.15 } },
    // 34
    { NKSelectL: { '0': 533.45, '600': 524.96, '1200': 430.87, '3000': 313.79 } },
    // 35
    { NKSelectL: { '0': 541.69, '600': 534.09, '1200': 439.12, '3000': 320.59 } },
    // 36
    { NKSelectL: { '0': 550.28, '600': 543.56, '1200': 447.72, '3000': 327.7 } },
    // 37
    { NKSelectL: { '0': 559.34, '600': 553.52, '1200': 456.76, '3000': 335.18 } },
    // 38
    { NKSelectL: { '0': 568.85, '600': 563.99, '1200': 466.27, '3000': 343.05 } },
    // 39
    { NKSelectL: { '0': 579.08, '600': 575.26, '1200': 476.49, '3000': 351.51 } },
    // 40
    { NKSelectL: { '0': 589.69, '600': 586.89, '1200': 487.09, '3000': 360.33 } },
    // 41
    { NKSelectL: { '0': 600.68, '600': 598.92, '1200': 498.07, '3000': 369.55 } },
    // 42
    { NKSelectL: { '0': 612.14, '600': 611.43, '1200': 509.5, '3000': 379.22 } },
    // 43
    { NKSelectL: { '0': 624.01, '600': 624.41, '1200': 521.35, '3000': 389.27 } },
    // 44
    { NKSelectL: { '0': 636.24, '600': 637.76, '1200': 533.56, '3000': 399.68 } },
    // 45
    { NKSelectL: { '0': 648.99, '600': 651.61, '1200': 546.29, '3000': 410.53 } },
    // 46
    { NKSelectL: { '0': 662.21, '600': 665.91, '1200': 559.49, '3000': 421.8 } },
    // 47
    { NKSelectL: { '0': 675.9, '600': 680.68, '1200': 573.16, '3000': 433.5 } },
    // 48
    { NKSelectL: { '0': 690.03, '600': 695.89, '1200': 587.27, '3000': 445.62 } },
    // 49
    { NKSelectL: { '0': 704.66, '600': 711.6, '1200': 601.86, '3000': 458.23 } },
    // 50
    { NKSelectL: { '0': 719.69, '600': 727.74, '1200': 616.87, '3000': 471.24 } },
    // 51
    { NKSelectL: { '0': 735.19, '600': 744.33, '1200': 632.34, '3000': 484.72 } },
    // 52
    { NKSelectL: { '0': 751.23, '600': 761.45, '1200': 648.34, '3000': 498.73 } },
    // 53
    { NKSelectL: { '0': 767.72, '600': 779.01, '1200': 664.79, '3000': 513.26 } },
    // 54
    { NKSelectL: { '0': 784.56, '600': 796.91, '1200': 681.62, '3000': 528.27 } },
    // 55
    { NKSelectL: { '0': 801.99, '600': 815.42, '1200': 699, '3000': 543.94 } },
    // 56
    { NKSelectL: { '0': 819.76, '600': 834.25, '1200': 716.73, '3000': 560.1 } },
    // 57
    { NKSelectL: { '0': 838.15, '600': 853.7, '1200': 735.07, '3000': 576.98 } },
    // 58
    { NKSelectL: { '0': 856.92, '600': 873.51, '1200': 753.79, '3000': 594.44 } },
    // 59
    { NKSelectL: { '0': 876.38, '600': 894.02, '1200': 773.18, '3000': 612.72 } },
    // 60
    { NKSelectL: { '0': 896.4, '600': 915.02, '1200': 793.12, '3000': 631.76 } },
    // 61
    { NKSelectL: { '0': 916.97, '600': 936.5, '1200': 813.62, '3000': 651.59 } },
    // 62
    { NKSelectL: { '0': 937.88, '600': 958.2, '1200': 834.46, '3000': 672.15 } },
    // 63
    { NKSelectL: { '0': 959.24, '600': 980.14, '1200': 855.74, '3000': 693.52 } },
    // 64
    {
        NKSelectL: { '0': 980.81, '600': 1002.21, '1200': 877.23, '3000': 715.68 },
    },
    // 65
    {
        NKSelectL: { '0': 1000.98, '600': 1022.77, '1200': 897.39, '3000': 736.94 },
    },
    // 66
    {
        NKSelectL: { '0': 1021.09, '600': 1043.26, '1200': 917.5, '3000': 758.17 },
    },
    // 67
    {
        NKSelectL: { '0': 1041.13, '600': 1063.59, '1200': 937.53, '3000': 779.31 },
    },
    // 68
    { NKSelectL: { '0': 1061, '600': 1083.67, '1200': 957.4, '3000': 800.26 } },
    // 69
    { NKSelectL: { '0': 1080.59, '600': 1103.44, '1200': 977, '3000': 820.91 } },
    // 70
    {
        NKSelectL: { '0': 1099.83, '600': 1122.78, '1200': 996.24, '3000': 841.16 },
    },
];
